import React from 'react';
import { styles } from '../../config/styles';
import { CHAIN_OPTIONS } from '../../constants/networks';

const ChainSelector = ({ selectedChain, onChange }) => {
    return (
        <div className="mb-6">
            <p className="block text-lg font-medium text-primary text-700 mb-2">
                What chain should we use?
            </p>
            <select
                id="chain"
                name="chain"
                value={selectedChain}
                onChange={onChange}
                className={`${styles.input.base} ${styles.input.focus}`}
            >
                {CHAIN_OPTIONS.map(({ value }) => (
                    <option key={value} value={value}>
                        {value}
                    </option>
                ))}
            </select>
        </div>
    );
};

export default ChainSelector;